import { List } from 'immutable';
import inputLengthConstants from '../../../../../constants/inputLengthConstants';
import FactorSetHoursLineOutput from '../../../../../interfaces/output/factorSetHoursLineOut';
import { ensure } from '../../../../../utils/arrayUtils';
import LanguageUtils from '../../../../../utils/LanguageUtils';
import ValidationModel from '../../../../../utils/validationModel';
import ValidationUtils from '../../../../../utils/validationUtils';

const inputsMaxLengths = {
    name: inputLengthConstants.String60
};

const messages = {
    requiredFields: LanguageUtils.createMessage('Validation error general')
};

export default class FactorSetHoursLineStep1Validation extends ValidationUtils {

    static validateInputHour(inputNumber?: number | string): boolean {
        const regexp = new RegExp(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/);

        const validationResult = inputNumber ? regexp.test(inputNumber.toString()) : false;

        return validationResult;
    }

    static validateFactorSetForm(factorSetLine: FactorSetHoursLineOutput): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;
        const { name,
            unitType,
            fromHours,
            toHours,
            factor,
            surcharge,
            surchargeCurrency
        } = factorSetLine;

        const requiredFields =
            this.validateName(name) &&
            this.validateInputNumber(unitType?.id, { required: surcharge ? true : false }) &&
            this.validateInputStringLength(fromHours) &&
            this.validateInputStringLength(toHours) &&
            this.validateInputNumber(factor) &&
            this.validateInputNumber(surchargeCurrency?.id, { required: surcharge ? true : false });

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        return validationModel;
    }

    static validateName = (inputString?: string): boolean => {
        return this.validateInputStringLength(inputString, {
            inputLength: inputsMaxLengths.name
        });
    }
}
